module.exports = "https://web-assets.ifttt.com/packs/media/icons/google_play_store_download-17f188c8.svg";